import App from "./App.tsx";
import "./index.css";
import '@unocss/reset/tailwind-compat.css'
import "virtual:uno.css";
import { hydrate, prerender as ssr } from "preact-iso";

// createRoot(document.getElementById("root")!).render(
//   <StrictMode>
//     <App />
//   </StrictMode>
// );

if (typeof window !== "undefined") {
  hydrate(<App />, document.body!);
}

export async function prerender(data: any) {
  return await ssr(<App {...data} />);
}
